import { render, staticRenderFns } from "./ShiftView.vue?vue&type=template&id=ad515d34&scoped=true&"
import script from "./ShiftView.vue?vue&type=script&lang=js&"
export * from "./ShiftView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad515d34",
  null
  
)

export default component.exports